import React, { useState } from 'react'

function Project({ data }) {
    let imagelist = data.images;
    const [Toggleclose, setToggleclose] = useState(0);

    const toggleHandler = (index) => {
        setToggleclose(index);
    }
    return (
        <div className='project_content'>
            <div>
                <div className='project_icon'>
                    <i className={data.icon_classname}></i>
                </div>
                <h3 className='project_title'>{data.title}</h3>
            </div>

            <span className="project_button" onClick={() => toggleHandler(1)}>
                View More
                <i className='uil uil-arrow-right project_button_icon'></i>
            </span>

            {/* =============== modal content =============== */}
            <div className={Toggleclose === 1 ? "project_modal active_modal" : "project_modal"}>
                <div className="project_modal_content">
                    <i className={ Toggleclose === 1 ? 'uil uil-times project_modal_close' :"uil uil-times project_modal_close modal_close_shake"}
                        onClick={() => toggleHandler(0)}></i>

                    <h3 className="project_modal_title">{data.title}</h3>
                    <p className="project_modal_description">{data.description}</p>

                    <div className={Toggleclose === 1 ? 'project_tech_stack' : "project_tech_stack invisible"} >
                        {
                            imagelist.map((image) => {
                                return (
                                    <img src={image} id={data.title}className='project_tech_icon' alt="tech_stack_icon">
                                    </img>
                                );
                            })
                        }
                    </div>

                    <a href={data.link} target='_blank' rel="noreferrer" className='modal_viewdemo'>View Demo</a>
                </div>
            </div>

        </div>
    )
}

export default Project